<template>
  <div v-if="data.id">
    <v-subheader class="font-weight-bold pt-3 pb-2">
      Endereços
      <v-spacer/>
      <v-btn depressed small color="teal" dark rounded @click="toggleForm">
        <v-icon size="16">mdi-plus</v-icon>
        Adicionar Endereço
      </v-btn>
    </v-subheader>
    <v-container fluid>
      <v-divider class="pb-2"/>
      <v-simple-table v-if="enderecos.length" fixed-header>
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-left">Principal</th>
            <th class="text-left">Logradouro</th>
            <th class="text-left">Bairro</th>
            <th class="text-left">Cidade / Estado</th>
            <th class="text-left">CEP</th>
            <th class="text-left">Complemento</th>
            <th class="text-left">Ações</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in enderecos" :key="index">
            <td>
              <v-btn v-if="item.id" fab x-small depressed tag="div" color="transparent"
                     @click="checkConfirm(item)">
                <v-icon :color="item.principal ? 'green' : 'red'" small>
                  {{ item.principal ? 'mdi-check-bold' : 'mdi-close-thick' }}
                </v-icon>
              </v-btn>
            </td>
            <td>
              {{ item.logradouro ? item.logradouro.nome : null }}
              {{ item.numero ? ', ' + item.numero : null }}
            </td>
            <td>{{ item.bairro ? item.bairro.nome : null }}</td>
            <td>
              {{ item.cidade ? item.cidade.nome : null }}
              {{ item.estado ? ' / ' + item.estado.nome : null }}
            </td>
            <td>{{ item.cep }}</td>
            <td>{{ item.complemento }}</td>
            <td>
              <v-btn @click="edit(item)"
                     fab depressed dark x-small color="indigo lighten-4" class="mr-2">
                <v-icon color="indigo" small>mdi-pencil</v-icon>
              </v-btn>
              <v-btn fab color="red lighten-4" dark x-small depressed @click="destroyConfirm(item)">
                <v-icon color="red">mdi-close</v-icon>
              </v-btn>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import cgmEnderecoHttp from '@/services/http/resources/configuracao/cgmEnderecoHttp';
import toastMessage, { confirmDestroyAlert, confirmDestroyAlertMessage } from '@/services/util/alertService';

export default {
  name: 'TableEnderecos',
  computed: {
    ...mapState('pessoa', ['data']),
    ...mapState('cgmEndereco', { enderecos: 'list' }),
  },
  created() {
    this.getAll(this.$route.params.id);
  },
  methods: {
    ...mapActions('cgmEndereco', ['getAll', 'toggleForm', 'edit', 'storeEnderecoAll', 'destroy']),
    destroyConfirm(item) {
      confirmDestroyAlert('Remover endereço?')
        .then((result) => {
          if (result.value) {
            this.destroy(item)
              .then(() => toastMessage.successDestroy('Endereço removido com sucesso'))
              .catch(() => toastMessage.errorDestroy('Erro ao remover endereço'));
          }
        });
    },
    checkConfirm(item) {
      confirmDestroyAlertMessage('Alteração', 'Deseja alterar endereço para principal?')
        .then((result) => {
          if (result.value) {
            cgmEnderecoHttp.checkPrincipal(item.id)
              .then(({ data: { data } }) => {
                this.storeEnderecoAll(data);
                toastMessage.successDestroy('Endereço alterado com sucesso');
              })
              .catch(() => toastMessage.errorDestroy('Erro ao alterar endereço'));
          }
        });
    },
  },
};
</script>
